/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://gthgiuc6hrcphb5uxme2yrjvjm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-uddbcqa7v5f5ln42lbccbiuxwi",
    "aws_cognito_identity_pool_id": "eu-central-1:52aad9e6-7910-4b2d-a9b2-6803dc3594af",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_lhQ57ZfSy",
    "aws_user_pools_web_client_id": "5qpbbiqj3quqf9mf56kmtv3mcj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
